import { Provider } from '@angular/core';

import { runOnAppInit } from '@frontend/vanilla/core';

import { PublicPageBreadcrumbBootstrapService } from './public-page-breadcrumb.bootstrapservice';

export function providePublicPageBreadcrumb(): Provider[] {
    return [runOnAppInit(PublicPageBreadcrumbBootstrapService)];
}
